import type { DeviceType, BaseEventParams } from './events'

/**
 * 디바이스 타입 감지
 */
export function getDeviceType(): DeviceType {
  const userAgent = navigator.userAgent.toLowerCase()

  if (/iphone/.test(userAgent)) {
    return 'iPhone'
  }
  if (/ipad/.test(userAgent)) {
    return 'iPad'
  }
  if (/android/.test(userAgent)) {
    return 'Android'
  }
  if (/macintosh|mac os x/.test(userAgent)) {
    return 'Mac'
  }
  if (/windows/.test(userAgent)) {
    return 'Window'
  }

  // 기본값
  return 'Window'
}

/**
 * User Pseudo ID 생성 (브라우저 세션 기반)
 * 로컬 스토리지에 저장하여 재사용
 */
export function getUserPseudoId(): string {
  const STORAGE_KEY = 'analytics_pseudo_id'

  // 기존 ID가 있으면 반환
  const existingId = localStorage.getItem(STORAGE_KEY)
  if (existingId) {
    return existingId
  }

  // 새 ID 생성
  const newId = `pseudo_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`
  localStorage.setItem(STORAGE_KEY, newId)

  return newId
}

/**
 * 이벤트 파라미터에 공통 정보 추가
 */
export function enrichEventParams<T extends BaseEventParams>(params: T): T {
  return {
    ...params,
    timestamp: Date.now(),
    device_type: getDeviceType(),
    user_pseudo_id: getUserPseudoId(),
  }
}

/**
 * 이메일에서 도메인 추출
 */
export function getEmailDomain(email: string): string {
  const parts = email.split('@')
  return parts.length > 1 ? parts[1] : ''
}
